import React, {useEffect, useMemo, useState} from 'react'
import {Col, Row} from 'react-bootstrap'

import Box from '../component/Box/Box'
import Page from '../component/Page/Page'
import CustomGrid from '../customGrid/CustomGrid'
import InventoryDetailGrid from '../customGrid/entities/InventoryDetailGrid'
import BreadcrumbItem from '../component/BreadcrumbItem/BreadcrumbItem'
import ProductTypeSelector from '../productType/component/ProductTypeSelector'
import InventoryDetailBox from './components/InventoryDetailBox'
import InventoryDashboard from './components/InventoryDashboard'
import IntentoryItemsHeaderCustom from "./components/inventoryItemSHeaderCustom";
import WebSocketTon from "../utils/WebSocket";
import UserService from "../services/UserService";

function InventoryDetailScreen({match, history}) {
  const [productTypeIdFilter, setProductTypeIdFilter] = useState(null)
  const [params, setParams] = useState(null)
  const [itemsRead, setItemsRead] = useState()
  const [realData, setRealData] = useState()

  const {inventoryId} = match.params
  const inventoryDetailGrid = useMemo(() => new InventoryDetailGrid(inventoryId, params), [params, inventoryId])
  const redirectToInventoryItemsScreen = (_tableState, {original}) => {
    history.push(`/inventories/${inventoryId}/items?productType=${original.productType && original.productType.id}`)
  }
  const executionData = itemsRead && itemsRead.executionData

  useEffect(() => {
    if(executionData != null && executionData.length > 0){
      setRealData(executionData)
    }
  }, [itemsRead]);

  useEffect(() => {
      const onMessageInWebSocket = (payload) => {
        setItemsRead(payload.payload);
      };

      let subscriptionInventoryRead = null;
      const subscribeInWS = async () => {
        subscriptionInventoryRead = await WebSocketTon.getInstance().subscribe(`/topic/companies/${UserService.getCompanyId()}/inventories/${inventoryId}/reads`, onMessageInWebSocket);
      }
      subscribeInWS();

      return () => {
        subscriptionInventoryRead && subscriptionInventoryRead.unsubscribe();
      }
    },
    []);

  const handleSetParams = () => {
    const urlSearchParams = new URLSearchParams({})
    productTypeIdFilter && urlSearchParams.append('productTypeId', productTypeIdFilter)
    setParams(urlSearchParams.toString())
  }

  useEffect(() => {
    handleSetParams()
  }, [productTypeIdFilter])

  return (
    <Page
      headerCustom={
        <IntentoryItemsHeaderCustom title="Detalhes do inventário" endpoint={inventoryDetailGrid.endpoint}/>
      }
      breadcrumbs={[
        <BreadcrumbItem key={1} title="Lista de inventários" to="/list/inventories"/>,
        <BreadcrumbItem key={2} title="Detalhes do inventário"/>,
      ]}>
      <InventoryDetailBox inventoryId={inventoryId}/>
      <InventoryDashboard inventoryId={inventoryId} itemsRead={itemsRead}/>
      <Box title="Produtos">
        <Row className="mb-3">
          <Col md={6}>
            <ProductTypeSelector setValue={setProductTypeIdFilter} value={productTypeIdFilter}/>
          </Col>
        </Row>
        {inventoryDetailGrid && <CustomGrid
          removeBox
          defaultSort={inventoryDetailGrid.defaultSort}
          onClickInRow={redirectToInventoryItemsScreen}
          metadata={inventoryDetailGrid}
          data={realData}
          endpoint={inventoryDetailGrid.endpoint}
        />}
      </Box>
    </Page>
  )
}

export default InventoryDetailScreen



// WEBPACK FOOTER //
// ./src/Inventory/InventoryDetailScreen.js